import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class ExpenseTypeService {

constructor(
            private http: HttpClient,
            private global: GlobalDataService
           ) { } 


   getExpenseType() {
        return this.http.get(this.global.httpUrl+"expenses/types");
   }

   getExpenseTypeById(id: any) {
        return this.http.get(this.global.httpUrl+"expenses/types/"+id);
   } 

   createExpenseType(data: any){
        return this.http.post(this.global.httpUrl+"expenses/types", data); 
   }

   updateExpenseType(data: any,id: any){
        return this.http.put(this.global.httpUrl+"expenses/types/"+id, data); 
   } 

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/expense_types/expense-type.service.ts